export const themes = {
  exclusive: {
    name: 'Luxury Oriental',
    colors: {
      background: '#ffffff',
      surface: '#faf9f6',
      surfaceHighlight: '#f3f0e8',
      primary: '#9c7a35', // or assombri : #c5a059 donnait 2,3:1 sur le fond crème
      primaryHover: '#85672b',
      secondary: '#2d2d2d',
      secondaryHover: '#1a1a1a',
      accent: '#d4af37',
      text: {
        main: '#1a1a1a',
        secondary: '#6b6b6b',
        accent: '#c5a059',
      },
      border: '#e5e1d5',
      success: '#8ba888',
      error: '#b85c5c',
      gradient: 'linear-gradient(135deg, #c5a059 0%, #e8d0a9 100%)',
    },
    fonts: {
      main: "'Montserrat', sans-serif",
      display: "'Playfair Display', serif",
    },
    shadows: {
      sm: '0 2px 10px rgba(0,0,0,0.05)',
      md: '0 5px 20px rgba(197, 160, 89, 0.1)',
      lg: '0 10px 40px rgba(0,0,0,0.08)',
    },
    borderRadius: {
      sm: '0.125rem',
      md: '0px',
      lg: '8px',
    },
    transitions: {
      default: 'all 0.3s ease',
      slow: 'all 0.6s ease',
    }
  },
  midnight: {
    name: 'Midnight Royal',
    colors: {
      background: '#0a0b10',
      surface: '#12141d',
      surfaceHighlight: '#1a1d29',
      primary: '#4a90e2', // Royal Blue
      primaryHover: '#357abd',
      secondary: '#e1e1e1', // Platinum
      secondaryHover: '#ffffff',
      accent: '#00d2ff',
      text: {
        main: '#ffffff',
        secondary: '#a0a0a0',
        accent: '#4a90e2',
      },
      border: '#2a2f3e',
      success: '#44d7b6',
      error: '#ff5a5f',
      gradient: 'linear-gradient(135deg, #4a90e2 0%, #00d2ff 100%)',
    },
    fonts: {
      main: "'Outfit', sans-serif",
      display: "'Bricolage Grotesque', sans-serif",
    },
    shadows: {
      sm: '0 2px 10px rgba(0,0,0,0.3)',
      md: '0 5px 20px rgba(74, 144, 226, 0.2)',
      lg: '0 10px 40px rgba(0,0,0,0.5)',
    },
    borderRadius: {
      sm: '4px',
      md: '12px',
      lg: '24px',
    },
    transitions: {
      default: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      slow: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
    }
  },
  artisan: {
    name: 'Natural Artisan',
    colors: {
      background: '#fdfcf0', // Creamy paper
      surface: '#f4f1de', 
      surfaceHighlight: '#e07a5f', // Terracotta
      primary: '#81b29a', // Sage Green
      primaryHover: '#6a9c84',
      secondary: '#3d405b', // Deep Navy
      secondaryHover: '#2a2d45',
      accent: '#f2cc8f', // Sand
      text: {
        main: '#3d405b',
        secondary: '#5f6368',
        accent: '#e07a5f',
      },
      border: '#dcdcc6',
      success: '#81b29a',
      error: '#e07a5f',
      gradient: 'linear-gradient(135deg, #81b29a 0%, #f2cc8f 100%)',
    },
    fonts: {
      main: "'Inter', sans-serif",
      display: "'Cormorant Garamond', serif",
    },
    shadows: {
      sm: '0 2px 4px rgba(61, 64, 91, 0.1)',
      md: '0 4px 12px rgba(61, 64, 91, 0.15)',
      lg: '0 8px 24px rgba(61, 64, 91, 0.2)',
    },
    borderRadius: {
      sm: '8px',
      md: '16px',
      lg: '32px',
    },
    transitions: {
      default: 'all 0.4s ease',
      slow: 'all 0.8s ease',
    }
  }
};

export const theme = themes.exclusive; // Fallback
